
export const sharedEnv = (key: string) => {
    if (typeof window === 'undefined' && process?.env) {
        return process.env[key];
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (import.meta) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return import.meta.env[`VITE_${key}`];
    }

    throw 'No env with key: ' + key;
};
